import PreviewContentLayout from "../../layouts/previewScreens/PreviewContentLayout";
import PreviewQuestionCorrectionContent from "./PreviewQuestionCorrectionContent";
import FlashQuestionContent from "../courses/flash/FlashQuestionContent";
import {isNullOrUndefined} from "../../../services/Validator";

export default function PreviewFlashQuestionContent({question, device, displayCorrection, refreshQuestion}) {
    // Used in PreviewQuestionScreen to display current exercisers
    // core content

    // BUILD
    if (isNullOrUndefined(question))
        return null
    return (
        <div className={"w-full h-full flex justify-center items-center"}>
            <div className={`${computeWidth()} flex flex-col justify-start items-center`}>
                <PreviewContentLayout>
                    {displayCorrection
                        ? <PreviewQuestionCorrectionContent question={question} />
                        : <FlashQuestionContent question={question}
                                                optionSelected={null}
                                                setOptionSelected={null}
                                                setOpenDontKnowDialog={null} />}
                </PreviewContentLayout>
            </div>
        </div>
    )

    // METHODS
    // ---- Compute content width
    function computeWidth() {
        switch (device) {
            case 'mobile':
                return "w-[375px]"
            case 'tablet':
                return "w-[640px]"
            case 'desktop':
                return "w-[1024px]"
            default:
                return "w-[768px]"
        }
    }
}